import React from 'react';

const AWS = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">Amazon Web Services</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">AWS</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>Amazon Web Services: Cloud Market Leader</h1>
                                    
                                    <p className="lead">AWS is the world's leading cloud platform with over 200+ services. It enables businesses to build, deploy, and scale applications with unprecedented flexibility. Chosen by startups, enterprises, and Fortune 500 companies.</p>

                                    <h3 className="mt-50">Unmatched Cloud Infrastructure</h3>
                                    <p>AWS pioneered cloud computing and continues to lead with the broadest and most mature set of services. Its global infrastructure, competitive pricing, and extensive ecosystem make it the default choice for cloud architecture.</p>

                                    <h3 className="mt-40">Comprehensive AWS Services</h3>
                                    <ul>
                                        <li><strong>EC2 & Compute:</strong> Scalable virtual servers with pay-as-you-go pricing</li>
                                        <li><strong>RDS & Database:</strong> Managed relational and NoSQL databases</li>
                                        <li><strong>S3 Storage:</strong> Industry-standard object storage at scale</li>
                                        <li><strong>Lambda & Serverless:</strong> Event-driven, serverless computing</li>
                                        <li><strong>CloudFront & CDN:</strong> Global content delivery network</li>
                                        <li><strong>CodePipeline & DevOps:</strong> Complete CI/CD automation</li>
                                        <li><strong>SQS & Messaging:</strong> Decoupled, scalable message queues</li>
                                        <li><strong>VPC & Security:</strong> Network isolation and security controls</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World AWS Architectures</h3>
                                    <p><strong>Startup Scaling:</strong> Startups scale from hundreds to millions of users using AWS auto-scaling.</p>
                                    <p><strong>Enterprise Migration:</strong> Large enterprises migrate data centers to AWS for cost and flexibility.</p>
                                    <p><strong>Global SaaS Platforms:</strong> Multi-region deployments with disaster recovery.</p>

                                    <h3 className="mt-40">AppCore's AWS Mastery</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Hyper-Scale Platform Infrastructure</h5>
                                        <p>We built a global platform on AWS:</p>
                                        <ul>
                                            <li>🚀 1M+ requests/second throughput</li>
                                            <li>💰 30% cost savings with Reserved Instances</li>
                                            <li>🌍 6-region global deployment</li>
                                            <li>📊 99.99% uptime SLA</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">AWS Architecture Patterns</h3>
                                    <ul>
                                        <li>Microservices with ECS & Kubernetes</li>
                                        <li>Serverless architecture with Lambda</li>
                                        <li>Database optimization and scaling</li>
                                        <li>Multi-region disaster recovery</li>
                                        <li>Cost optimization strategies</li>
                                        <li>Security and compliance frameworks</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">AWS Advantages</h5>
                                    <ul className="sidebar-list">
                                        <li>🌍 Global Infrastructure</li>
                                        <li>💰 Cost Competitive</li>
                                        <li>⚡ High Performance</li>
                                        <li>🔒 Enterprise Security</li>
                                        <li>📈 Auto Scaling</li>
                                        <li>🛠️ Extensive Tools</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Infrastructure Metrics</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">AWS Projects</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>35+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Global Regions</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>30+</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">Availability</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>99.99%</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Enterprise & Startup Favorite</h5>
                                    <p className="small">Over 1 million active customers choose AWS for its breadth of services, global reach, and market leadership in cloud computing.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AWS;
